/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { flip, Placement } from '@floating-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  onCancel: () => void;
  onSave: (date: Date | null) => void;
  value: string | null;
  calendarDirection?: Placement;
  handleOpen: () => void;
  handleClose: () => void;
}
const DateInput = (props: Props) => {
  const { value, onCancel, onSave, calendarDirection, handleOpen, handleClose } = props;
  const initialDate = value ? new Date(value) : null;
  const [date, setDate] = useState<Date | null>(initialDate);

  return (
    <div className="d-inline-flex align-items-center">
      <DatePicker
        selected={date}
        onChange={(val: Date | null) => setDate(val)}
        dateFormat="dd/MM/yyyy"
        className="timeline-date-input"
        popperPlacement={calendarDirection}
        showPopperArrow
        popperModifiers={
          calendarDirection
            ? [
                flip({
                  fallbackPlacements: calendarDirection.includes('bottom')
                    ? ['bottom-start', 'bottom-end']
                    : ['top-start', 'top-end'],
                }),
              ]
            : undefined
        }
        onCalendarOpen={handleOpen}
        onCalendarClose={handleClose}
      />
      <div className="d-flex flex-row">
        <button
          className="timeline-date-button ok"
          type="button"
          onClick={() => {
            onSave(date);
          }}
        >
          <FontAwesomeIcon icon="check" />
        </button>
        <button className="timeline-date-button cancel" type="button" onClick={onCancel}>
          <FontAwesomeIcon icon="times" />
        </button>
      </div>
    </div>
  );
};

export default DateInput;
